import React from 'react';
import {DatePicker, DatePickerProps} from 'rsuite';
import {Control, Controller, RegisterOptions, useController} from 'react-hook-form';
import cn from 'classnames';

import {PALETTE} from 'shared/config/model/palette';

import {getInputState} from '../../Input/inputHelper';
import Correct from '../../icons/General/Correct';
import Wrong from '../../icons/General/Wrong';
import Edit from '../../icons/General/Edit';

import {isTranslate} from '../../../lib/lang';

import styles from './DateRangePickerControlled.module.scss';

export interface IDatePickerControlledProps extends DatePickerProps{
    control: Control<any>,
    name: string,
    rules?: RegisterOptions,
    validate?: boolean;
}

const DatePickerControlled: React.FC<IDatePickerControlledProps> = ({
    control,
    name,
    rules,
    validate = true,
    defaultValue,
    onChange,
    placeholder= 'Выберите дату...',
    ...rest
}) => {
    const { field, fieldState } = useController({
        name,
        control,
        defaultValue,
    });

    const dateFormat = !isTranslate() ? 'dd.MM.yyyy' : 'yyyy-MM-dd';

    const state = getInputState({
        fieldState,
        value: field.value,
        validate,
    });

    const iconsMap = {
        valid: <Correct color={PALETTE.accent}/>,
        error: <Wrong/>,
        filled: <Edit />,
        default: <Edit />,
    };

    const classMap = {
        valid: styles.item_valid,
        error: styles.item_error,
        filled: styles.item_filled,
        default: styles.item_default,
    };

    return (
        <div className={styles.item_container}>
            <div className={styles.icon}>
                {iconsMap[state]}
            </div>
            <Controller
                control={control}
                name={name}
                rules={rules}
                defaultValue={defaultValue}
                render={({field: {onChange: onChangeFrom, ...field}}) => (
                    <DatePicker
                        onChange={(value, event) => {
                            onChangeFrom(value);
                            onChange && onChange(value, event);
                        }}
                        className={cn(styles.item, classMap[state])}
                        placeholder={placeholder}
                        format={dateFormat}
                        preventOverflow
                        {...rest}
                        {...field}
                    />
                )}
            />
        </div>
    );
};

export default DatePickerControlled;